import React, {useState, useEffect} from 'react'
import ProgramsHierarchy from '@/shared/components/ProgramsHierarchy'
import { connect } from 'react-redux'
import { withRouter, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import Select from 'react-select'
import axios from 'axios'

import {clone} from 'lodash';
import {Button, Col, Row} from "reactstrap";

const ImportFilter = ({onClickFilterCallback, organization, programs, auth, useOrg = true}) => {
  const options = {
    'programs': true,
    'programId': false,
  }
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const configFromUrl = params.get('config') ? parseInt(params.get('config')) : null;

  const [selectedPrograms, setSelectedPrograms] = useState(programs ? programs : []);
  const [keyword, setKeyword] = React.useState('');
  const [configurations, setConfigurations] = useState([]);
  const [selectedConfig, setSelectedConfig] = useState(configFromUrl);

  useEffect(() => {
    if (organization?.id) {
      axios.get(`/organization/${organization.id}/csv-import-setting`)
        .then(res => {
          const opts = (res.data?.data || [])
            .sort((a, b) => a.id - b.id)
            .map(c => ({ value: c.id, label: `#${c.id} — ${c.name || 'No name'}` }));
          setConfigurations(opts);
        });
    }
  }, [organization?.id]);

    const onProgramPhaseChange = (e) => {
        setKeyword( e.target.value)
    }
    const onClickFilter = (event, reset = false) => {
        event.preventDefault();
        if (reset) {
            setKeyword('');
            setSelectedPrograms([]);
            setSelectedConfig(null);
            onClickFilterCallback('', [], null);
        } else {
            onClickFilterCallback(keyword, clone(selectedPrograms), selectedConfig);
        }
    }
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onClickFilter(e);
        }
    }
    return (
      <Row className="table-filter-form form">
        <Col md={8} lg={8} sm={8} className="table-filter-form-fields">
          <div>
            {useOrg && auth?.isSuperAdmin &&
            <div className="table-filter-form-col table-filter-form-col1 float-filter" style={{paddingTop: 4}}>
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <ProgramsHierarchy
                        defaultPrograms={options.programs}
                        selectedPrograms={selectedPrograms}
                        setSelectedPrograms={setSelectedPrograms}
                    />
                  </div>
                </div>
              </div>
            </div>
            }
            <div className="table-filter-form-col table-filter-form-col3 float-filter">
              <div className="form__form-group">
                <span className="form__form-group-label" style={{ whiteSpace: 'nowrap' }}>Configuration:</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row" style={{ minWidth: 220 }}>
                    <Select
                      options={configurations}
                      isClearable
                      isSearchable
                      className="react-select"
                      classNamePrefix="react-select"
                      placeholder="All configurations"
                      value={configurations.find(c => c.value === selectedConfig) || null}
                      onChange={opt => setSelectedConfig(opt ? opt.value : null)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="table-filter-form-col table-filter-form-col3 float-filter">
              <div className="form__form-group">
                <span className="form__form-group-label" style={{ whiteSpace: 'nowrap' }}>File Name:</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input
                        value={keyword}
                        onChange={onProgramPhaseChange}
                        onKeyDown={handleKeyDown}
                        type="text"
                        placeholder="Search by File Name"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col className="align-items-center max-height-32px pl-1">
          <Button
              onClick={(e)=>onClickFilter(e)}
              className="btn btn-sm btn-primary"
              color="#ffffff"
          >Filter</Button>
          <Button
              onClick={(e)=>onClickFilter(e,true)}
              className="btn btn-sm btn-primary"
              color="#ffffff"
          >Reset</Button>
        </Col>
      </Row>
    )
}

ImportFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onClickFilterCallback: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  useOrg: PropTypes.bool
};

ImportFilter.defaultProps = {
  useOrg: true,
  value:''
};

export default withRouter(connect((state) => ({
    auth: state.auth,
    organization: state.organization
}))(ImportFilter));